export const payrollOvertime = [
  {
    key:"1",
    Name: "Normal day OT 1.5x",
    Rate: "Hourly 1.5",
  },
  {
    key:"2",
    Name: "Public holiday OT 3.0x",
    Rate: "Hourly 3",
  },
  {
    key:"3",
    Name: "Rest day OT 2.0x",
    Rate: "Hourly 2",
  },
];
